export default __webpack_public_path__ + "static/media/ep3collage3.2842e796.jpg";